module.exports = __webpack_public_path__ + "img/moto.fa134c19.png";